<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">Jira Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable Jira</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !username.value}">
			<span class="col-lg-2">Username:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="username" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiToken.value}">
			<span class="col-lg-2">API Token:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiToken" (keydown)="onPasswordKeyDownHandler($event)"/>
			</div>
		</div>
		<div class="jira-default-settings-divider"></div>
		<div class="row" style="padding-top: 10px;">
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save Jira Default Settings"></button>
			</div>
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="testConnection()" [disabled]="!enableTestJiraButton" title="Test/Verify Jira connection credentials" label="Test Jira Connection"></button>
			</div>
		</div>
		<div class="jira-default-settings-divider"></div>
	</form>
</div>